import { Typography, Stack, useTheme, Skeleton } from '@mui/material';

import RasterImage from '~components/media/rasterImage';
import { PageHeaderInfo } from '~layouts/interfaces/pageHeaderInfo';
import { Dimens } from '~themes';

interface PageHeaderProps {
	isLoading?: boolean;
	headerInfo?: PageHeaderInfo;
}

const PageHeader = ({ isLoading = false, headerInfo }: PageHeaderProps) => {
	const { palette } = useTheme();
	return (
		<Stack direction='row' spacing={Dimens.spacingXl}>
			{!isLoading && headerInfo?.imageName && (
				<RasterImage name={headerInfo?.imageName} objectFit='cover' size={80} />
			)}
			<Stack direction='column' justifyContent='center'>
				{headerInfo?.title && (
					<Typography variant='headingSm' color={palette.textPrimary.main}>
						{isLoading ?
							<Skeleton width={Dimens.spacing10xl} />
						:	headerInfo?.title}
					</Typography>
				)}
				{headerInfo?.subHeaderText ||
					(isLoading && (
						<Typography variant='labelSm' color={palette.textPrimary.main}>
							{isLoading ?
								<Skeleton width={Dimens.spacing8xl} />
							:	headerInfo?.subHeaderText}
						</Typography>
					))}
				{!isLoading && headerInfo?.subHeaderComponent}
			</Stack>
		</Stack>
	);
};
export default PageHeader;
